<template>
  <div class="form-container">
    <!-- Form -->
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="first_name" class="text-start d-block">
          <i class="bi bi-person-fill"></i> First Name
        </label>
        <input type="text" v-model="form.first_name" id="first_name" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="last_name" class="text-start d-block">
          <i class="bi bi-person-fill"></i> Last Name
        </label>
        <input type="text" v-model="form.last_name" id="last_name" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="institute_name" class="text-start d-block">
          <i class="bi bi-building"></i> Institute Name
        </label>
        <input type="text" v-model="form.institute_name" id="institute_name" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="address" class="text-start d-block">
          <i class="bi bi-geo-alt-fill"></i> Address
        </label>
        <input type="text" v-model="form.address" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="contact" class="text-start d-block">
          <i class="bi bi-telephone-fill"></i> Contact
        </label>
        <input type="text" v-model="form.contact" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="email" class="text-start d-block">
          <i class="bi bi-envelope-fill"></i> Email
        </label>
        <input type="email" v-model="form.email" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="password" class="text-start d-block">
          <i class="bi bi-lock-fill"></i> Password
        </label>
        <div class="input-group">
          <input :type="passwordVisible ? 'text' : 'password'" v-model="form.password" id="password" class="form-control" required />
          <span class="input-group-text" @click="togglePasswordVisibility">
            <i :class="passwordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="confirm_password" class="text-start d-block">
          <i class="bi bi-lock-fill"></i> Confirm Password
        </label>
        <input :type="passwordVisible ? 'text' : 'password'" v-model="form.confirmPassword" id="confirm_password" class="form-control" required />
      </div>

      <div class="form-group">
        <label for="location" class="text-start d-block">
          <i class="bi bi-geo-alt-fill"></i> Location
        </label>
        <select v-model="form.location" class="form-control" required>
          <option v-for="location in locations" :key="location.id" :value="location.id">
            {{ location.name }}
          </option>
        </select>
      </div>

      <div class="form-group mt-3">
  <label for="priceRate" class="text-start d-block">
    <i class="bi bi-cash-coin"></i> Price Rate
  </label>
  <select v-model="form.priceRate" class="form-control" required>
    <option disabled value="">Select Rate</option>
    <option v-for="rate in priceRates" :key="rate" :value="rate">{{ rate }}%</option>
  </select>
</div>


      <div class="form-group">
        <label for="profile_photo" class="text-start d-block">
          <i class="bi bi-image-fill"></i> Profile Photo
        </label>
        <input type="file" @change="handleFileUpload" id="profile_photo" class="form-control" required />
      </div>

      <!-- Success Message -->
      <div v-if="successMessage" class="alert alert-success">
        <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="alert alert-danger">
        <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
      </div>

      <!-- Submit Button -->
      <button type="submit" class="btn btn-primary" :disabled="isLoading">
        <template v-if="isLoading">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Submitting...
        </template>
        <template v-else>
          <i class="bi bi-send-fill"></i> Submit
        </template>
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        institute_name: '',
        address: '',
        contact: '',
        email: '',
        password: '',
        confirmPassword: '',
        location: null,
        priceRate: '',
        profile_photo: null,
      },
      locations: [],
      priceRates: Array.from({ length: 16 }, (_, i) => (i + 1) * 5), // 5 to 80
      errorMessage: '', // To display error messages
      successMessage: '', // To display success messages
      passwordVisible: false, // To toggle password visibility
      isLoading: false, // To track loading state
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    async submitForm() {
      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = 'Passwords do not match.';
        return;
      }

      const formData = new FormData();
      formData.append('first_name', this.form.first_name);
      formData.append('last_name', this.form.last_name);
      formData.append('institute_name', this.form.institute_name);
      formData.append('address', this.form.address);
      formData.append('contact', this.form.contact);
      formData.append('email', this.form.email);
      formData.append('password', this.form.password);
      formData.append('location', this.form.location);
      
      // Convert percentage to decimal
      const decimalRate = this.form.priceRate / 100;
      formData.append('price_rate', decimalRate); // Append decimal version

      formData.append('profile_photo', this.form.profile_photo);

      this.isLoading = true; // Start loading

try {
  const response = await axios.post('/institute-register', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  // Check if the response contains success or error
  if (response.data.success) {
    this.successMessage = response.data.success;
    this.errorMessage = ''; // Clear error message if any
  }
} catch (error) {
  // Check if the error response contains validation or custom error messages
  if (error.response && error.response.data.errors) {
    // Handle Laravel validation errors
    this.errorMessage = Object.values(error.response.data.errors)
      .flat()
      .join(', '); // Combine all error messages
    this.successMessage = ''; // Clear success message if any
  } else if (error.response && error.response.data.error) {
    // Handle custom backend error
    this.errorMessage = error.response.data.error;
    this.successMessage = ''; // Clear success message if any
  } else {
    // Fallback for unexpected errors
    this.errorMessage = 'An unexpected error occurred.';
    this.successMessage = '';
  }
} finally {
  this.isLoading = false; // Stop loading
}

console.log('Form submitted!');
// Emit the event to notify the parent component
this.$emit('instituteAdded');
},
    handleFileUpload(event) {
      this.form.profile_photo = event.target.files[0];
    },
    async fetchLocations() {
      try {
        const response = await axios.get('/get-all-locations');
        this.locations = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching locations.';
      }
    }
  },
  created() {
    this.fetchLocations();
  },
};
</script>

<style scoped>
.alert {
  margin-bottom: 20px;
}
.form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.text-start {
  text-align: left;
}
.form-group label i {
  margin-right: 5px;
}
.input-group {
  display: flex;
  align-items: center;
}
.input-group-text {
  cursor: pointer;
}
</style>
